/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import { loadScript } from '../../scripts/helpers';
import { trustpilotScriptUrl, trustpilotScriptId, trustPilotWidgetUrl } from '../../scripts/data';

interface TrustpilotWidgetProps {}
class TrustpilotWidget extends React.Component<TrustpilotWidgetProps> {
  trustBoxRef: React.RefObject<HTMLDivElement> = React.createRef<HTMLDivElement>();

  componentDidMount() {
    if (!window.Trustpilot) {
      loadScript(trustpilotScriptUrl, trustpilotScriptId)
        .then(() => {
          if (this.trustBoxRef?.current && window.Trustpilot) {
            window.Trustpilot.loadFromElement(this.trustBoxRef.current, true);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else if (window.Trustpilot && this.trustBoxRef?.current) {
      window.Trustpilot.loadFromElement(this.trustBoxRef.current, true);
    }
  }

  render() {
    return (
      <a
        className="trustpilot-outer position-relative my-5 my-lg-0 me-lg-4 d-table mx-auto"
        href={trustPilotWidgetUrl}
        target="_blank"
        data-link-both="public-footer-trustpilot-widget"
        rel="noopener noreferrer"
        title="Trust Pilot Reviews"
        aria-label="Trust Pilot Reviews">
        <div
          className="trustpilot-widget"
          ref={this.trustBoxRef}
          data-locale="en-US"
          data-template-id="5419b757fa0340045cd0c938"
          data-businessunit-id="5513972d0000ff00057e4c5b"
          data-style-height="25px"
          data-style-width="180px"></div>
      </a>
    );
  }
}

export default TrustpilotWidget;
